import React from 'react';

import { assembleFloorPlanHeaderTextData } from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanHelpers';

import DetailHeader from '../Detail/DetailHeader';
import CommunityContact from '../Community/CommunityContact';

import './FloorPlanPrintIndividualPage.scss';

const FloorPlanPrintIndividualPage = ( props ) => {
  const {
    children,
    floorPlanData,
    logoLoaded,
    setLogoLoaded
  } = props;

  const {
    title,
    community,
  } = floorPlanData || {};

  const {
    name,
    logo,
    email,
    phone,
  } = community || {};

  const communityData = {};
  communityData.community = {
    email,
    phone,
  };

  const headerData = assembleFloorPlanHeaderTextData(
    floorPlanData,
    null,
    null,
    true,
    false,
  );

  return (
    <div className="floorPlanPrintPage__individualPage">

      <div className="floorPlanPrintPage__header">
        <div className="floorPlanPrintPage__branding">
          <img
            className="floorPlanPrintPage__logo"
            src={logo}
            alt={name}
            onLoad={() => {
              if ( !logoLoaded ) {
                setLogoLoaded( true );
              }
            }}
          />
        </div>
      </div>

      <DetailHeader
        title={title}
        data={headerData}
      />

      { children }

      <div className="floorPlanPrintPage__footer">
        <div className="floorPlanPrintPage__contactWrapper">
          <CommunityContact
            className="floorPlanPrintPage__contact"
            residentCommunityData={communityData}
          />
        </div>
      </div>

    </div>
  );
};

export default FloorPlanPrintIndividualPage;
